export const ENROLL_OPTIONS_MEDICARE = ["Yes", "No"]

export const ENROLL_OPTIONS_MEDICAID = ['Yes', 'No']